import { makeAutoObservable } from 'mobx';
import { UiStore } from '@/stores/ui';
import { getLocalStorageValue, setLocalStorageValue } from '@/utils/localStorage';

const NAVBAR_COLLAPSED_KEY = 'navbar-collapsed';
const NAVBAR_WIDTH_KEY = 'navbar-width';
const NAVBAR_DEFAULT_WIDTH = 255;

export class NavbarStore {
  collapsed = false;
  width = 255;

  constructor(public readonly uiStore: UiStore) {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });

    const defaultCollapsed = this.uiStore.isMobile ? 'true' : 'false';

    this.collapsed = getLocalStorageValue(NAVBAR_COLLAPSED_KEY, defaultCollapsed) === 'true';
    this.width = parseInt(
      getLocalStorageValue(NAVBAR_WIDTH_KEY, NAVBAR_DEFAULT_WIDTH.toString()) ??
        NAVBAR_DEFAULT_WIDTH.toString()
    );
  }

  toggle() {
    this.collapsed = !this.collapsed;
    setLocalStorageValue(NAVBAR_COLLAPSED_KEY, this.collapsed ? 'true' : 'false');
  }

  setWidth(width: number) {
    this.width = width;
    setLocalStorageValue(NAVBAR_WIDTH_KEY, width.toString());
  }
}
